<template>
  <div id="pageSettings">
    <v-container fluid class="pl-3 pr-3 pl-sm-6 pr-sm-6 pt-0 mt-0">
      <!-- Encabezado de la página -->
      <v-row class="mb-2">
        <v-col cols="12">
          <h1 class="text-h5 text-sm-h4 font-weight-bold primary--text">
            <v-icon large left color="primary">mdi-cog</v-icon>
            Configuración
          </h1>
          <div class="subtitle-1 grey--text">Personaliza la apariencia y seguridad de tu cuenta</div>
        </v-col>
      </v-row>
      <!-- Navegación con v-tabs para todos los dispositivos -->
       <!-- Navegación con v-tabs para todos los dispositivos -->       <v-card flat class="mb-4">
        <v-tabs
          v-model="viewMode"
          background-color="white"
          color="primary"
          :show-arrows="$vuetify.breakpoint.smAndDown"
          slider-color="primary"
          :dense="$vuetify.breakpoint.smAndDown"
          centered
          grow
        >
          <!-- Datos personales - Visible para todos -->
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-account</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Datos personales' }}</span>
          </v-tab>

          <!-- Comodatos - Solo para manager, logistics y sales -->
          <v-tab v-if="canAccessAdvancedSettings">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-view-grid-outline</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Comodatos' }}</span>
          </v-tab>

          <!-- Personalización - Solo para manager, logistics y sales -->
          <v-tab v-if="canAccessAdvancedSettings">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-palette</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Personalización' }}</span>
          </v-tab>

          <!-- Seguridad - Visible para todos -->
          <v-tab>
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-shield-lock</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Seguridad' }}</span>
          </v-tab>

          <!-- Notificaciones - Visible si tiene permiso manage_notifications o roles avanzados -->
          <v-tab v-if="canSeeNotifications">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-bell</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Notificaciones' }}</span>
          </v-tab>

          <!-- Alertas - Visible si tiene permiso manage_notifications o roles avanzados -->
          <v-tab v-if="canSeeNotifications">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-alert</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Alertas' }}</span>
          </v-tab>

          <!-- Equipamiento - Visible si tiene permiso manage_equipamiento_config o roles avanzados -->
          <v-tab v-if="canSeeEquipamiento">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-wrench</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'Equip. Básico' }}</span>
          </v-tab>

          <!-- Categorías To-Do - Visible para configuraciones avanzadas -->
          <v-tab v-if="canAccessToDo">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-format-list-checks</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'TO-DO' }}</span>
          </v-tab>

          <!-- Categorías ESTADO PROCESO - Visible para configuraciones avanzadas -->
          <v-tab v-if="canAccessProcesos">
            <v-icon :left="$vuetify.breakpoint.mdAndUp" class="mb-1 mb-md-0">mdi-format-list-checks</v-icon>
            <span class="ml-0 ml-md-1">{{ $vuetify.breakpoint.smAndDown ? '' : 'ESTADO PROCESO' }}</span>
          </v-tab>
        </v-tabs>
      </v-card>

      <v-tabs-items v-model="viewMode">
        <!-- DATOS PERSONALES -->
        <v-tab-item>
          <v-row justify="center">
            <v-col cols="12" md="8" lg="7">
              <v-card class="elevation-2 rounded-lg my-5">
                <v-card-title class="py-4 primary--text">
                  <v-icon left color="primary">mdi-account</v-icon>
                  Datos personales
                </v-card-title>

                <v-divider></v-divider>

                <v-card-text class="pa-4">
                  <!-- Header de tarjeta con estado -->
                  <div class="d-flex flex-column flex-sm-row justify-space-between align-start align-sm-center mb-3">
                    <div class="d-flex mb-3 mb-sm-0">
                      <v-avatar size="56" color="secondary" class="mr-3">
                        <v-icon size="32" color="primary">mdi-account</v-icon>
                      </v-avatar>
                      <div>
                        <div class="subtitle-1 font-weight-medium mb-1">
                          {{ user ? `${user.name} ${user.lastname}` : 'Cargando...' }}
                        </div>
                        <div class="caption grey--text text--darken-1">
                          {{ user ? user.username : '' }}
                        </div>
                      </div>
                    </div>
                    <v-btn text small color="primary" @click="showUserForm(user)" class="mt-0">
                      <v-icon left small>mdi-pencil</v-icon>
                      <span class="d-none d-sm-inline">Modificar información</span>
                      <span class="d-inline d-sm-none">Modificar</span>
                    </v-btn>
                  </div>

                  <!-- Información básica -->
                  <v-list dense class="pa-0 transparent">
                    <v-list-item class="px-0">
                      <v-list-item-icon class="mr-2">
                        <v-icon color="grey darken-1">mdi-email</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{ user ? user.email || 'Sin email' : 'Cargando...'
                          }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="px-0">
                      <v-list-item-icon class="mr-2">
                        <v-icon color="grey darken-1">mdi-phone</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-subtitle>{{ user ? user.phone || 'Sin teléfono' : 'Cargando...'
                          }}</v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="px-0">
                      <v-list-item-icon class="mr-2 align-self-start pt-1">
                        <v-icon color="grey darken-1">mdi-shield-account</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          <div class="d-flex flex-wrap">
                            <template v-if="user && user.roles">
                              <v-chip v-for="(rol, index) in user.roles" :key="index" x-small outlined class="mr-1 mb-1"
                                color="primary">
                                {{ getRoleName(rol) }}
                              </v-chip>
                            </template>
                            <template v-else>
                              <span>Cargando roles...</span>
                            </template>
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item class="px-0">
                      <v-list-item-icon class="mr-2 align-self-start pt-1">
                        <v-icon color="grey darken-1">mdi-shield-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-subtitle>
                          <div class="d-flex flex-wrap">
                            <v-chip
                              v-for="permission in formattedPermissions"
                              :key="permission.key"
                              x-small
                              outlined
                              class="mr-1 mb-1"
                              color="success"
                            >
                              {{ permission.label }}
                            </v-chip>
                            <span v-if="formattedPermissions.length === 0" class="text-caption grey--text">
                              No hay permisos específicos asignados
                            </span>
                          </div>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>        
        <!-- COMODATOS - Solo para manager, logistics y sales -->
        <v-tab-item v-if="canAccessAdvancedSettings">
          <v-row justify="center">
            <v-col cols="12" md="8" lg="7">
              <v-card class="elevation-2 rounded-lg my-5">
                <v-card-title class="py-4 primary--text">
                  <v-icon left color="primary">mdi-view-grid-outline</v-icon>
                  Comodatos
                </v-card-title>

                <v-divider></v-divider>

                <v-form ref="comodatosForm" v-model="validationsComodatos.isValid">
                  <v-card-text class="pa-4">
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-text-field v-model="fields.company_name" :disabled="saving"
                          :rules="validationsComodatos.company_name" :error-messages="errorsComodatos.company_name"
                          label="Nombre Empresa" outlined dense prepend-inner-icon="mdi-domain"
                          placeholder="Ingrese el nombre de la empresa" hide-details="auto" class="mb-3"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-text-field v-model="fields.company_address" :disabled="saving"
                          :rules="validationsComodatos.company_address"
                          :error-messages="errorsComodatos.company_address" label="Dirección" outlined dense
                          prepend-inner-icon="mdi-map-marker-radius" placeholder="Ingrese la dirección de la empresa"
                          hide-details="auto" class="mb-3"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-text-field v-model="fields.cif" :disabled="saving" :rules="validationsComodatos.cif"
                          :error-messages="errorsComodatos.cif" label="CIF" outlined dense
                          prepend-inner-icon="mdi-identifier" placeholder="Ingrese el CIF de la empresa"
                          hide-details="auto" class="mb-3"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <v-text-field
                          v-model="fields.euros_per_km_exceeded"
                          :disabled="saving"
                          type="number"
                          step="0.01"
                          label="Euros por KM excedido"
                          outlined
                          dense
                          prepend-inner-icon="mdi-currency-eur"
                          placeholder="0.15"
                          hide-details="auto"
                          class="mb-3"
                          suffix="€/km"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="mb-3">
                          <label class="v-label theme--light mb-2 d-block">Límites de KM diarios</label>
                          <div class="d-flex align-center mb-2">
                            <v-text-field
                              v-model="newKmLimit"
                              :disabled="saving"
                              type="number"
                              outlined
                              dense
                              prepend-inner-icon="mdi-map-marker-distance"
                              placeholder="Ingrese límite de kilómetros"
                              hide-details
                              class="mr-2"
                              @keyup.enter="addKmLimit"
                            ></v-text-field>
                            <v-btn
                              color="primary"
                              :disabled="!newKmLimit || saving"
                              @click="addKmLimit"
                              small
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="fields.km_limits && fields.km_limits.length > 0" class="d-flex flex-wrap">
                            <v-chip
                              v-for="(kmLimit, index) in fields.km_limits"
                              :key="index"
                              close
                              @click:close="removeKmLimit(index)"
                              @click="setDefaultKmLimit(index)"
                              class="mr-2 mb-2"
                              :color="fields.default_km_limit_index === index ? 'success' : 'grey'"
                              :outlined="fields.default_km_limit_index !== index"
                              small
                              style="cursor: pointer;"
                            >
                              <v-icon v-if="fields.default_km_limit_index === index" left x-small>mdi-star</v-icon>
                              <v-icon v-else left x-small>mdi-map-marker-distance</v-icon>
                              {{ kmLimit }} km
                            </v-chip>
                          </div>
                          <div v-else class="text-caption grey--text">
                            No hay límites de KM agregados
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="mb-3">
                          <label class="v-label theme--light mb-2 d-block">Franquicias</label>
                          <div class="d-flex align-center mb-2">
                            <v-text-field
                              v-model="newFranchise"
                              :disabled="saving"
                              type="number"
                              outlined
                              dense
                              prepend-inner-icon="mdi-crown"
                              placeholder="Ingrese valor de franquicia"
                              hide-details
                              class="mr-2"
                              @keyup.enter="addFranchise"
                            ></v-text-field>
                            <v-btn
                              color="primary"
                              :disabled="!newFranchise || saving"
                              @click="addFranchise"
                              small
                            >
                              <v-icon small>mdi-plus</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="fields.franchises && fields.franchises.length > 0" class="d-flex flex-wrap">
                            <v-chip
                              v-for="(franchise, index) in fields.franchises"
                              :key="index"
                              close
                              @click:close="removeFranchise(index)"
                              @click="setDefaultFranchise(index)"
                              class="mr-2 mb-2"
                              :color="fields.default_franchise_index === index ? 'primary' : 'grey'"
                              :outlined="fields.default_franchise_index !== index"
                              small
                              style="cursor: pointer;"
                            >
                              <v-icon v-if="fields.default_franchise_index === index" left x-small>mdi-star</v-icon>
                              <v-icon v-else left x-small>mdi-crown</v-icon>
                              {{ franchise }}€
                            </v-chip>
                          </div>
                          <div v-else class="text-caption grey--text">
                            No hay franquicias agregadas
                          </div>
                        </div>
                      </v-col>

                      <!-- <v-col cols="12" sm="6">
                        <v-text-field v-model="fields.wear_value" :disabled="saving"
                          :rules="validationsComodatos.wear_value" :error-messages="errorsComodatos.wear_value"
                          label='Valor "desgaste"' outlined dense prepend-inner-icon="mdi-abacus"
                          placeholder="Ingrese el valor de desgaste" hide-details="auto" class="mb-3"></v-text-field>
                      </v-col> -->

                      <v-col cols="12" sm="6">
                        <div class="d-flex flex-column flex-md-row">
                          <div class="logo-preview mr-md-3 mb-4 mb-md-0">
                            <v-avatar size="65" color="grey lighten-3" class="elevation-2">
                              <v-img v-if="fields.signature_image_url" :src="fields.signature_image_url" alt="Signature Img" contain></v-img>
                              <v-icon v-else size="35" color="grey">mdi-image-outline</v-icon>
                            </v-avatar>
                          </div>
                          <div class="upload-control flex-grow-1 pt-2">
                            <v-file-input v-model="fields._signature_image" :disabled="saving" label="Seleccionar firma empresa" outlined dense
                              accept="image/png, image/jpeg" prepend-icon="mdi-image" placeholder="Seleccione una imagen con la firma de su empresa"
                              hint="Formato recomendado: PNG o JPG (máx. 2MB)" @change="previewFirma"
                              persistent-hint></v-file-input>
                          </div>
                        </div>
                      </v-col>

                      <v-col cols="12" sm="6">
                        <div class="d-flex flex-column flex-md-row">
                          <div class="logo-preview mr-md-3 mb-4 mb-md-0">
                            <v-avatar size="65" color="grey lighten-3" class="elevation-2">
                              <v-img v-if="fields.stamp_image_url" :src="fields.stamp_image_url" alt="Stamp Img" contain></v-img>
                              <v-icon v-else size="35" color="grey">mdi-image-outline</v-icon>
                            </v-avatar>
                          </div>
                          <div class="upload-control flex-grow-1 pt-2">
                            <v-file-input v-model="fields._stamp_image" :disabled="saving" label="Seleccionar sello empresa" outlined dense
                            accept="image/png, image/jpeg" prepend-icon="mdi-image" placeholder="Seleccione una imagen con el sello de su empresa"
                              hint="Formato recomendado: PNG o JPG (máx. 2MB)" @change="previewSello"
                              persistent-hint></v-file-input>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="saving" :disabled="saving || !validationsComodatos.isValid"
                      @click="saveDataComodatos">
                      <v-icon left>mdi-content-save</v-icon>
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>        
        <!-- PERSONALIZACIÓN - Solo para manager, logistics y sales -->
        <v-tab-item v-if="canAccessAdvancedSettings">
          <v-row justify="center">
            <v-col cols="12" md="8" lg="7">
              <v-card class="elevation-2 rounded-lg my-5">
                <v-card-title class="py-4 primary--text text-center">
                  <v-icon left color="primary">mdi-palette</v-icon>
                  Personalización
                </v-card-title>

                <v-divider></v-divider>

                <v-form ref="settingsForm" v-model="validations.isValid">
                  <v-card-text class="pa-4">
                    <!-- Logo de la empresa -->
                    <h3 class="subtitle-1 font-weight-medium mb-3 text-center">Logo de la empresa</h3>
                    <div class="d-flex flex-column flex-md-row align-center mb-5">
                      <div class="logo-preview mr-md-5 mb-4 mb-md-0">
                        <v-avatar size="100" color="grey lighten-3" class="elevation-2">
                          <v-img v-if="logoPreview" :src="logoPreview" alt="Logo" contain></v-img>
                          <v-icon v-else size="48" color="grey">mdi-image-outline</v-icon>
                        </v-avatar>
                      </div>

                      <div class="upload-control flex-grow-1">
                        <v-file-input v-model="fields.logo" :disabled="saving" label="Seleccionar logo" outlined dense
                          accept="image/*" prepend-icon="mdi-image" placeholder="Seleccione una imagen para su logo"
                          @change="previewLogo" hint="Formato recomendado: PNG o JPG (máx. 2MB)"
                          persistent-hint></v-file-input>
                      </div>
                    </div>

                    <!-- <v-divider class="my-3"></v-divider> -->

                    <!-- Selector de tema -->
                    <!--<h3 class="subtitle-1 font-weight-medium mb-3 text-center">Tema de la aplicación</h3>

                    <v-select v-model="fields.theme" :items="themes" :item-text="theme => theme.text"
                      :item-value="theme => theme.value" :disabled="saving" outlined dense
                      prepend-inner-icon="mdi-palette-outline" hint="El tema se aplicará a toda la aplicación"
                      persistent-hint>
                      <template v-slot:selection="data">
                        <div class="d-flex align-center">
                          <div class="theme-color-preview d-flex mr-2">
                            <div v-for="color in data.item.colors" :key="color"
                              :style="{ backgroundColor: color, width: '20px', height: '20px', display: 'inline-block', marginRight: '2px', borderRadius: '2px' }">
                            </div>
                          </div>
                          <span>{{ data.item.text }}</span>
                        </div>
                      </template>

                      <template v-slot:item="data">
                        <div class="d-flex align-center py-2">
                          <div class="theme-color-preview d-flex mr-3">
                            <div v-for="color in data.item.colors" :key="color"
                              :style="{ backgroundColor: color, width: '24px', height: '24px', display: 'inline-block', marginRight: '3px', borderRadius: '3px' }">
                            </div>
                          </div>
                          <span class="font-weight-medium">{{ data.item.text }}</span>
                        </div>
                      </template>
                    </v-select>-->
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="saving" :disabled="saving || !validations.isValid"
                      @click="saveData">
                      <v-icon left>mdi-content-save</v-icon>
                      Guardar cambios
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- SEGURIDAD -->
        <v-tab-item>
          <v-row justify="center">
            <v-col cols="12" md="8" lg="7">
              <v-card class="elevation-2 rounded-lg my-5">
                <v-card-title class="py-4 primary--text text-center">
                  <v-icon left color="primary">mdi-shield-lock</v-icon>
                  Seguridad
                </v-card-title>

                <v-divider></v-divider>

                <v-form ref="passwordForm" v-model="passwordValid">
                  <v-card-text class="pa-4">
                    <h3 class="subtitle-1 font-weight-medium mb-4 text-center">Cambiar contraseña</h3>

                    <v-alert type="info" text color="primary" class="mb-4" icon="mdi-information-outline" dense>
                      Por seguridad, tu contraseña debe tener al menos 8 caracteres y contener letras y números.
                    </v-alert>

                    <!-- Campo de nueva contraseña -->
                    <v-text-field v-model="fields.newPassword" :disabled="saving2"
                      :type="showNewPassword ? 'text' : 'password'" :rules="validations.newPassword"
                      :error-messages="errors.newPassword" label="Nueva Contraseña" outlined dense
                      prepend-inner-icon="mdi-lock-outline" :append-icon="showNewPassword ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showNewPassword = !showNewPassword" placeholder="Ingrese su nueva contraseña"
                      class="mb-4"></v-text-field>

                    <!-- Campo de confirmación de contraseña -->
                    <v-text-field v-model="fields.newPasswordConfirm" :disabled="saving2"
                      :type="showNewPasswordConfirm ? 'text' : 'password'" :rules="validations.newPasswordConfirm"
                      :error-messages="errors.newPasswordConfirm" label="Confirmar Nueva Contraseña" outlined dense
                      prepend-inner-icon="mdi-lock-check-outline"
                      :append-icon="showNewPasswordConfirm ? 'mdi-eye-off' : 'mdi-eye'"
                      @click:append="showNewPasswordConfirm = !showNewPasswordConfirm"
                      placeholder="Repita su nueva contraseña"></v-text-field>

                    <!-- Indicador de fortaleza de contraseña -->
                    <v-card v-if="fields.newPassword" outlined class="mb-2 pa-3">
                      <div class="d-flex flex-column">
                        <div class="d-flex align-center mb-2">
                          <div class="subtitle-2 font-weight-medium mr-2">Fortaleza:</div>
                          <div class="ml-2 font-weight-medium" :class="`${passwordStrength.color}--text`">
                            {{ passwordStrength.text }}
                          </div>
                        </div>
                        <v-progress-linear :value="passwordStrength.score * 25" :color="passwordStrength.color"
                          height="8" rounded class="mb-1"></v-progress-linear>

                        <div class="d-flex flex-wrap mt-3">
                          <v-chip small class="mr-1 mb-1" :color="fields.newPassword.length >= 8 ? 'success' : 'grey'"
                            :text-color="fields.newPassword.length >= 8 ? 'success' : ''" outlined>
                            <v-icon left x-small>{{ fields.newPassword.length >= 8 ? 'mdi-check' : 'mdi-close'
                              }}</v-icon>
                            8+ caracteres
                          </v-chip>
                          <v-chip small class="mr-1 mb-1"
                            :color="/[0-9]/.test(fields.newPassword) ? 'success' : 'grey'"
                            :text-color="/[0-9]/.test(fields.newPassword) ? 'success' : ''" outlined>
                            <v-icon left x-small>{{ /[0-9]/.test(fields.newPassword) ? 'mdi-check' : 'mdi-close'
                              }}</v-icon>
                            Número
                          </v-chip>
                            <v-chip small class="mr-1 mb-1"
                            :color="/[a-zA-Z]/.test(fields.newPassword) ? 'success' : 'grey'"
                            :text-color="/[a-zA-Z]/.test(fields.newPassword) ? 'success' : ''" outlined>
                            <v-icon left x-small>{{ /[a-zA-Z]/.test(fields.newPassword) ? 'mdi-check' : 'mdi-close'
                              }}</v-icon>
                            Letra
                            </v-chip>
                        </div>
                      </div>
                    </v-card>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" :loading="saving2" :disabled="saving2 || !isPasswordFormValid"
                      @click="changePassword">
                      <v-icon left>mdi-lock-reset</v-icon>
                      Cambiar Contraseña
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>        
        <!-- NOTIFICACIONES - Visible para quien tenga permiso o roles avanzados -->
        <v-tab-item v-if="canSeeNotifications">
                <v-row justify="center">
                  <v-col cols="12" md="10" lg="8">
                    <notification-settings />
                  </v-col>
                </v-row>
        </v-tab-item>        
        <!-- ALERTAS - Visible para quien tenga permiso o roles avanzados -->
        <v-tab-item v-if="canSeeNotifications">
          <v-row justify="center">
            <v-col cols="12" md="8" lg="7">
              <v-card class="elevation-2 rounded-lg my-5">
                <v-card-title class="py-4 primary--text text-center">
                  <v-icon left color="primary">mdi-alert</v-icon>
                  Alertas
                </v-card-title>

                <v-divider></v-divider>

                <v-form ref="alertsForm" v-model="validationsAlerts.isValid">
                  <v-card-text class="pa-4">
                    <v-card class="alert-timeline-card mb-4 rounded-lg" outlined>
                      <div class="alert-timeline-header pa-2 primary lighten-5 text-center">
                        <h3 class="text-subtitle-1 font-weight-medium mb-0">Períodos de alerta entre estados</h3>
                      </div>

                      <v-timeline dense class="pt-3 pb-2 pl-3">
                        <v-timeline-item color="amber" small fill-dot>
                          <div class="d-flex flex-column flex-sm-row align-start align-sm-center mb-3">
                            <div class="font-weight-medium mb-2 mb-sm-0 mr-sm-3">SIN REPORTAR → REPORTADO</div>
                            <v-spacer class="d-none d-sm-block"></v-spacer>
                            <v-text-field v-model="fields.alert_period_from_unreported_to_reported" :disabled="saving"
                              :rules="validationsAlerts.alert_period_from_unreported_to_reported"
                              :error-messages="errorsAlerts.alert_period_from_unreported_to_reported" suffix="horas"
                              type="number" outlined dense hide-details="auto" style="max-width: 120px;"></v-text-field>
                          </div>
                        </v-timeline-item>

                        <v-timeline-item color="blue" small fill-dot>
                          <div class="d-flex flex-column flex-sm-row align-start align-sm-center mb-3">
                            <div class="font-weight-medium mb-2 mb-sm-0 mr-sm-3">REPORTADO → EN PROCESO</div>
                            <v-spacer class="d-none d-sm-block"></v-spacer>
                            <v-text-field v-model="fields.alert_period_from_reported_to_processing" :disabled="saving"
                              :rules="validationsAlerts.alert_period_from_reported_to_processing"
                              :error-messages="errorsAlerts.alert_period_from_reported_to_processing" suffix="horas"
                              type="number" outlined dense hide-details="auto" style="max-width: 120px;"></v-text-field>
                          </div>
                        </v-timeline-item>

                        <v-timeline-item color="green" small fill-dot>
                          <div class="mb-2">
                            <div class="font-weight-medium mb-2 text-center">EN PROCESO → COMPLETADO</div>

                            <v-card flat class="pa-2 grey lighten-5 rounded-lg">
                              <div class="d-flex flex-column flex-sm-row align-start align-sm-center mb-2">
                                <div class="d-flex align-center mb-2 mb-sm-0 mr-sm-3">
                                  <v-icon color="primary" left small class="mr-1">mdi-account-hard-hat</v-icon>
                                  <div class="caption mr-2">CONDUCTOR:</div>
                                </div>
                                <v-spacer class="d-none d-sm-block"></v-spacer>
                                <v-text-field v-model="fields.alert_period_from_processing_to_completed_driver"
                                  :disabled="saving"
                                  :rules="validationsAlerts.alert_period_from_processing_to_completed_driver"
                                  :error-messages="errorsAlerts.alert_period_from_processing_to_completed_driver"
                                  suffix="horas" type="number" outlined dense hide-details="auto"
                                  style="max-width: 120px;"></v-text-field>
                              </div>

                              <div class="d-flex flex-column flex-sm-row align-start align-sm-center mb-2">
                                <div class="d-flex align-center mb-2 mb-sm-0 mr-sm-3">
                                  <v-icon color="primary" left small class="mr-1">mdi-tow-truck</v-icon>
                                  <div class="caption mr-2">GRÚA:</div>
                                </div>
                                <v-spacer class="d-none d-sm-block"></v-spacer>
                                <v-text-field v-model="fields.alert_period_from_processing_to_completed_crane"
                                  :disabled="saving"
                                  :rules="validationsAlerts.alert_period_from_processing_to_completed_crane"
                                  :error-messages="errorsAlerts.alert_period_from_processing_to_completed_crane"
                                  suffix="horas" type="number" outlined dense hide-details="auto"
                                  style="max-width: 120px;"></v-text-field>
                              </div>

                              <div class="d-flex flex-column flex-sm-row align-start align-sm-center mb-2">
                                <div class="d-flex align-center mb-2 mb-sm-0 mr-sm-3">
                                  <v-icon color="primary" left small class="mr-1">mdi-account-tie</v-icon>
                                  <div class="caption mr-2">CLIENTE:</div>
                                </div>
                                <v-spacer class="d-none d-sm-block"></v-spacer>
                                <v-text-field v-model="fields.alert_period_from_processing_to_completed_customer"
                                  :disabled="saving"
                                  :rules="validationsAlerts.alert_period_from_processing_to_completed_customer"
                                  :error-messages="errorsAlerts.alert_period_from_processing_to_completed_customer"
                                  suffix="horas" type="number" outlined dense hide-details="auto"
                                  style="max-width: 120px;"></v-text-field>
                              </div>

                              <div class="d-flex flex-column flex-sm-row align-start align-sm-center">
                                <div class="d-flex align-center mb-2 mb-sm-0 mr-sm-3">
                                  <v-icon color="primary" left small class="mr-1">mdi-account</v-icon>
                                  <div class="caption mr-2">YO MISMO:</div>
                                </div>
                                <v-spacer class="d-none d-sm-block"></v-spacer>
                                <v-text-field v-model="fields.alert_period_from_processing_to_completed_myself"
                                  :disabled="saving"
                                  :rules="validationsAlerts.alert_period_from_processing_to_completed_myself"
                                  :error-messages="errorsAlerts.alert_period_from_processing_to_completed_myself"
                                  suffix="horas" type="number" outlined dense hide-details="auto"
                                  style="max-width: 120px;"></v-text-field>
                              </div>
                            </v-card>
                          </div>
                        </v-timeline-item>
                      </v-timeline>
                    </v-card>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions class="pa-4 justify-center">
                    <v-btn color="primary" :loading="saving" :disabled="saving || !validationsAlerts.isValid"
                      @click="saveDataConfig">
                      <v-icon left>mdi-content-save</v-icon>
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item v-if="canSeeEquipamiento">
          <v-row justify="center">
            <v-col>
              <equipment-settings
                :dealership-id="dealershipId"
                :fields.sync="fields"
                :user-state="userState"
                :loading="loading"
                :saving="saving"
                :validations-noti="validationsNoti"
                :errors-noti="errorsNoti"
                :selected-responsable-mov="selectedResponsableMov"
                @remove-responsable="removeResponsableMov"
                @save-config="saveDataConfig"
                @update-responsible-users="updateEquipmentResponsibleUsers"
              />
            </v-col>
          </v-row>
        </v-tab-item>

        <!-- CATEGORÍAS DE TAREAS -->
        <v-tab-item v-if="canAccessToDo">
          <v-row justify="center">
            <v-col cols="12" md="10" lg="9">
              <todo-category-settings />
            </v-col>
          </v-row>
        </v-tab-item>
        <!-- ESTADO PROCESO -->
        <v-tab-item v-if="canAccessProcesos">
          <v-row justify="center">
            <v-col cols="12" md="10" lg="9">
              <estado-proceso-settings />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs-items>
    </v-container>
    <!-- Modal para editar usuario (sin cambios) -->
    <user-form v-if="visibleForm" v-model="editItem" @save="updateDataTable" @cancel="visibleForm = false" :is-limited-edit="isLimitedEdit"></user-form>
  </div>
</template>

<script>
import UserService from '@/services/UserService'
import DealerService from '@/services/DealerService'
import { mapGetters } from 'vuex/dist/vuex.common.js'

const STATUS_DISABLED = 0
const STATUS_ENABLED = 10

export default {
  components: {
    UserForm: () => import(/* webpackPrefetch: true */ '../user/UserForm'),
    NotificationSettings: () => import('./NotificationSettings'),
    EquipmentSettings: () => import('../../components/EquipmentSettings'),
    TodoCategorySettings: () => import('../../components/TodoCategorySettings'),
    EstadoProcesoSettings: () => import('../../components/EstadoProcesoSettings')
  },
  data: () => ({
    loading: false,
    viewMode: 0,
    viewModeVehiculoEquip: 0,
    viewModeVehiculoEquipFirstRecep: 0,
    viewModeVehiculoEquipMov: 0,
    saving: false,
    saving2: false,
    logoPreview: null,
    showNewPasswordConfirm: false,
    showNewPassword: false,
    passwordValid: true,
    user: null,
    newFranchise: null, // Variable temporal para agregar franquicias
    newKmLimit: null, // Variable temporal para agregar límites de KM
    // Agregar configuración de pestañas para móvil
    tabs: [
      { value: 'personal', label: 'Datos personales', icon: 'mdi-account' },
      { value: 'comodatos', label: 'Comodatos', icon: 'mdi-view-grid-outline' },
      { value: 'theme', label: 'Personalización', icon: 'mdi-palette' },
      { value: 'security', label: 'Seguridad', icon: 'mdi-shield-lock' },
      { value: 'notifications', label: 'Notificaciones', icon: 'mdi-bell' },
      { value: 'alerts', label: 'Alertas', icon: 'mdi-alert' },
      { value: 'equipment', label: 'Equipamiento', icon: 'mdi-wrench' },
      { value: 'todo-categories', label: 'Categorías de Tareas', icon: 'mdi-format-list-checks' }
    ],
    estados: [
      { name: 'Habilitado', value: STATUS_ENABLED },
      { name: 'Deshabilitado', value: STATUS_DISABLED }
    ],
    roleDisplay: {
      admin: 'Administrador',
      logistics: 'Logística',
      manager: 'Manager',
      commercial: 'Vendedor',
      sales: 'Jefe de ventas',
      driver: 'Conductor',      
      garage: 'Jefe de Taller',
      mechanic: 'Mecánico',
      cleaning: 'Limpieza'
    },
    selectedResponsable: [],
    selectedResponsableMov: [],
    selectedResponsableAlerts: [],

    visibleForm: false,
    editItem: null,
    isLimitedEdit: false, // Indica si la edición es limitada (solo nombre, apellidos, teléfono)

    // Opciones de tema
    // themes: [
    //   {
    //     text: 'Light',
    //     value: 'light',
    //     colors: ['#ffffff', '#f5f5f5', '#c0c0c0']
    //   },
    //   {
    //     text: 'Dark',
    //     value: 'dark',
    //     colors: ['#212121', '#424242', '#9e9e9e']
    //   },
    //   {
    //     text: 'Blue',
    //     value: 'blue',
    //     colors: ['#bbdefb', '#64b5f6', '#1e88e5']
    //   },
    //   {
    //     text: 'Green',
    //     value: 'green',
    //     colors: ['#a5d6a7', '#66bb6a', '#388e3c']
    //   },
    //   {
    //     text: 'Red',
    //     value: 'red',
    //     colors: ['#ff5252', '#ff1744', '#d50000']
    //   }
    // ],

    userState: {
      list: [],
      loading: false,
      search: '',
      search2: '',
      search3: ''
    },

    // Campos del formulario
    fields: {
      logo: null,
      // theme: null,
      newPasswordConfirm: '',
      newPassword: '',
      newVehicleResponsibleMail: null,
      newMovementResponsibleMail: null,
      alert_period_from_unreported_to_reported: 0,
      alert_period_from_reported_to_processing: 0,
      alert_period_from_processing_to_completed_driver: 0,
      alert_period_from_processing_to_completed_crane: 0,
      alert_period_from_processing_to_completed_customer: 0,
      alert_period_from_processing_to_completed_myself: 0,
      inProcessResponsibleMail: null,
      company_name: null,
      company_address: null,
      cif: null,
      // wear_value: null,
      franchises: [], // Array de franquicias
      km_limits: [], // Array de límites de KM
      default_franchise_index: null, // Índice de franquicia predeterminada
      default_km_limit_index: null, // Índice de límite de KM predeterminado
      euros_per_km_exceeded: null, // Euros por KM excedido
      _signature_image: null,
      _stamp_image: null,
      signature_image_url: null,
      stamp_image_url: null,
      // Campos de equipamiento - Vehículos nuevos
      equip_luz_v16: false,
      equip_triangulo: false,
      equip_chaleco_reflectante: false,
      equip_cable_carga: false,
      
      // Campos de equipamiento - Vehículos usados
      equip_luz_v16_used: false,
      equip_triangulo_used: false,
      equip_chaleco_reflectante_used: false,
      equip_cable_carga_used: false,
      
      // Campos de equipamiento - Movimientos de vehículos usados
      equip_luz_v16_mov_used: false,
      equip_triangulo_mov_used: false,
      equip_chaleco_reflectante_mov_used: false,
      equip_cable_carga_mov_used: false,
      
      // Campos de obligatoriedad para movimientos
      equip_luz_v16_required_mov_used: false,
      equip_triangulo_required_mov_used: false,
      equip_chaleco_required_mov_used: false,
      equip_cable_carga_required_mov_used: false
    },

    // Validaciones
    validations: {
      isValid: true,
      newPassword: [
        v => !!v || 'La nueva contraseña es requerida',
        v => v.length >= 8 || 'La nueva contraseña debe tener al menos 8 caracteres',
        v => /\d/.test(v) || 'La contraseña debe incluir al menos un número',
        v => /[a-zA-Z]/.test(v) || 'La contraseña debe incluir al menos una letra'
      ],
      newPasswordConfirm: [
        v => !!v || 'La confirmación de la nueva contraseña es requerida'
      ]
    },
    validationsNoti: {
      isValid: true,
      responsible: [
        (v) => !!v || 'Debe proporcionar un responsable.'
      ],
      responsibleMov: [
        (v) => !!v || 'Debe proporcionar un responsable.'
      ]
    },
    validationsComodatos: {
      isValid: true,
      company_name: [
        (v) => !!v || 'Debe proporcionar el nombre de la empresa.'
      ],
      company_address: [
        (v) => !!v || 'Debe proporcionar la dirección de la empresa.'
      ],
      cif: [
        (v) => !!v || 'Debe proporcionar el CIF de la empresa.'
      ]
      // Las franquicias son opcionales, no requieren validación
    },
    validationsAlerts: {
      isValid: true,
      alert_period_from_unreported_to_reported: [
      v => (v !== null && v !== '' && !isNaN(Number(v))) || 'Debe ser un número'
      ],
      alert_period_from_reported_to_processing: [
      v => (v !== null && v !== '' && !isNaN(Number(v))) || 'Debe ser un número'
      ],
      alert_period_from_processing_to_completed_driver: [
      v => (v !== null && v !== '' && !isNaN(Number(v))) || 'Debe ser un número'
      ],
      alert_period_from_processing_to_completed_crane: [
      v => (v !== null && v !== '' && !isNaN(Number(v))) || 'Debe ser un número'
      ],
      alert_period_from_processing_to_completed_customer: [
      v => (v !== null && v !== '' && !isNaN(Number(v))) || 'Debe ser un número'
      ],
      alert_period_from_processing_to_completed_myself: [
      v => (v !== null && v !== '' && !isNaN(Number(v))) || 'Debe ser un número'
      ],
      responsible: [
      v => !!v || 'Debe proporcionar un responsable.'
      ]
    },

    validationsEquipment: {
      isValid: true,
      equipment_name: [
        (v) => !!v || 'Debe proporcionar el nombre del equipo.'
      ],
      equipment_type: [
        (v) => !!v || 'Debe proporcionar el tipo de equipo.'
      ],
      equipment_serial_number: [
        (v) => !!v || 'Debe proporcionar el número de serie del equipo.'
      ],
      equipment_responsible: [
        (v) => !!v || 'Debe proporcionar un responsable para el equipo.'
      ]
    },

    // Errores
    errors: {
      newPassword: [],
      newPasswordConfirm: []
    },
    errorsNoti: {
      responsible: [],
      responsibleMov: []
    },
    errorsComodatos: {
      company_name: [],
      company_address: [],
      cif: []
    },
    errorsAlerts: {
      alert_period_from_unreported_to_reported: [],
      alert_period_from_reported_to_processing: [],
      alert_period_from_processing_to_completed_driver: [],
      alert_period_from_processing_to_completed_crane: [],
      alert_period_from_processing_to_completed_customer: [],
      alert_period_from_processing_to_completed_myself: [],
      responsible: []
    },
    errorsEquipment: {
      equipment_name: [],
      equipment_type: [],
      equipment_serial_number: [],
      equipment_responsible: []
    }
  }),
  computed: {
    ...mapGetters(['CURRENT_USER', 'CURRENT_USER_PERMISSIONS']),

    // Computed property para dealershipId que persiste correctamente
    dealershipId() {
      if (this.CURRENT_USER && this.CURRENT_USER.dealer && this.CURRENT_USER.dealer.id) {
        return this.CURRENT_USER.dealer.id
      }
      return null
    },

    // Verificar si el usuario puede acceder a configuraciones avanzadas
    canAccessAdvancedSettings () {
      // Los admins NO pueden acceder a configuraciones avanzadas
      if (this.$store.getters.HAS_ROLE(['admin'])) {
        return false
      }
      
      // Mostrar configuraciones avanzadas si el usuario tiene permiso 'manage_dealer'
      if (this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('manage_dealer')) {
      return true
      }
      if (this.$store.getters.HAS_ROLE(['colaborator']) || (this.CURRENT_USER && this.CURRENT_USER.dealer.is_colaborador)) {
        return true
      }
      if (Array.isArray(this.CURRENT_USER_PERMISSIONS)) {
      return this.CURRENT_USER_PERMISSIONS.includes('manage_dealer')
      }
      return false
    },
    canAccessToDo () {
      // Los admins NO pueden acceder a configuración de TODO
      if (this.$store.getters.HAS_ROLE(['admin'])) {
        return false
      }
      
      // Mostrar configuraciones avanzadas si el usuario tiene permiso 'crear_todo'
      console.log('Verificando permiso para crear_todo')
      console.log(this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('crear_todo'))
      if (this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('crear_todo')) {
      return true
      }
      if (Array.isArray(this.CURRENT_USER_PERMISSIONS)) {
      return this.CURRENT_USER_PERMISSIONS.includes('editar_todo')
      }
      return false
    },
    canAccessProcesos () {
      // Los admins NO pueden acceder a configuración de Procesos
      if (this.$store.getters.HAS_ROLE(['admin'])) {
        return false
      }
      
      // Mostrar configuraciones avanzadas si el usuario tiene permiso 'crear_estado_proceso'
      console.log(this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('crear_estado_proceso'))
      if (this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('crear_estado_proceso')) {
      return true
      }
      if (Array.isArray(this.CURRENT_USER_PERMISSIONS)) {
      return this.CURRENT_USER_PERMISSIONS.includes('editar_estado_proceso')
      }
      return false
    },

    // Permisos basados en permisos específicos o roles avanzados
    canSeeNotifications() {
      // Los admins NO pueden ver notificaciones
      if (this.$store.getters.HAS_ROLE(['admin'])) {
        return false
      }
      
      // Mostrar Notificaciones y Alertas si tiene permiso manage_notifications o es rol avanzado
      if (this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('manage_notifications')) {
        return true
      }
      // return this.canAccessAdvancedSettings
      return false
    },

    canSeeEquipamiento() {
      // Los admins NO pueden ver equipamiento
      if (this.$store.getters.HAS_ROLE(['admin'])) {
        return false
      }
      
      // Mostrar Equipamiento si tiene permiso manage_equipamiento_config o es rol avanzado
      if (this.$store.getters.HAS_PERMISSION && this.$store.getters.HAS_PERMISSION('manage_equipamiento_config')) {
        return true
      }
      return false
    },

    isPasswordFormValid () {
      return (
        this.passwordValid &&
        this.fields.newPassword &&
        this.fields.newPasswordConfirm &&
        this.fields.newPassword === this.fields.newPasswordConfirm
      )
    },

    passwordStrength () {
      if (!this.fields.newPassword) {
        return { score: 0, text: 'Ninguna', color: 'grey' }
      }

      const password = this.fields.newPassword
      let score = 0

      // Longitud
      if (password.length >= 12) score += 2
      else if (password.length >= 8) score += 1

      // Complejidad
      if (/[A-Z]/.test(password)) score += 1
      if (/[a-z]/.test(password)) score += 1
      if (/\d/.test(password)) score += 1
      if (/[^A-Za-z0-9]/.test(password)) score += 1

      // Mapear a nivel de fortaleza
      let result = { score: 0, text: 'Muy débil', color: 'red' }

      if (score >= 5) {
        result = { score: 4, text: 'Muy fuerte', color: 'success' }
      } else if (score === 4) {
        result = { score: 3, text: 'Fuerte', color: 'light-green' }
      } else if (score === 3) {
        result = { score: 2, text: 'Media', color: 'amber' }
      } else if (score === 2) {
        result = { score: 1, text: 'Débil', color: 'orange' }
      }

      return result
    },

    formattedPermissions() {
      if (!this.CURRENT_USER_PERMISSIONS || this.CURRENT_USER_PERMISSIONS.length === 0) {
        return []
      }

      // Mapeo de permisos a nombres legibles
      const permissionLabels = {
        // Usuarios
        'manage_users': 'Gestionar usuarios',
        'agregar_usuario_normal': 'Agregar usuario normal',
        'actualizar_usuario': 'Actualizar usuario',
        'eliminar_usuario': 'Eliminar usuario',
        
        // Vehículos
        'crear_vehiculo': 'Crear vehículo',
        'editar_vehiculo': 'Editar vehículo',
        'eliminar_vehiculo': 'Eliminar vehículo',
        'importacion_masiva_excel': 'Importación masiva Excel',
        
        // Conductores
        'crear_conductor': 'Crear conductor',
        'editar_conductor': 'Editar conductor',
        'eliminar_conductor': 'Eliminar conductor',
        
        // Movimientos
        'crear_movimiento': 'Crear movimiento',
        'editar_movimiento': 'Editar movimiento',
        'eliminar_movimiento': 'Eliminar movimiento',
        
        // Grúas
        'crear_grua': 'Crear grúa',
        'editar_grua': 'Editar grúa',
        'eliminar_grua': 'Eliminar grúa',
        
        // Ubicaciones
        'crear_ubicacion': 'Crear ubicación',
        'editar_ubicacion': 'Editar ubicación',
        'eliminar_ubicacion': 'Eliminar ubicación',
        
        // Dealer
        'manage_dealer': 'Gestionar dealer',
        'manage_equipamiento_config': 'Gestionar configuración de equipamiento',
        'manage_notifications': 'Gestionar notificaciones',
        'descargar_comodato': 'Descargar comodato'
      }

      return this.CURRENT_USER_PERMISSIONS.map(permission => ({
        key: permission,
        label: permissionLabels[permission] || permission.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())
      })).sort((a, b) => a.label.localeCompare(b.label))
    }
  },

  watch: {
    // 'fields.theme': function (newTheme) {
    //   if (newTheme) {
    //     document.documentElement.setAttribute('data-theme', newTheme)
    //     localStorage.setItem('theme', newTheme)

    //     // Aplicar tema Vuetify
    //     this.$vuetify.theme.dark = newTheme === 'dark'
    //     if (newTheme !== 'dark' && newTheme !== 'light') {
    //       this.$vuetify.theme.themes.light.primary = this.themes.find(theme => theme.value === newTheme).colors[1]
    //       this.$vuetify.theme.themes.light.secondary = this.themes.find(theme => theme.value === newTheme).colors[0]
    //       this.$vuetify.theme.themes.light.accent = this.themes.find(theme => theme.value === newTheme).colors[2]
    //     }
    //   }
    // },

    'fields.newPasswordConfirm': function (newPasswordConfirm) {
      if (newPasswordConfirm && newPasswordConfirm === this.fields.newPassword) {      
        this.errors.newPasswordConfirm = []
      } else if (newPasswordConfirm) {
        this.errors.newPasswordConfirm = ['Las contraseñas no coinciden']
      }
    },

    selectedResponsable: function(newUsers) {
      this.fields.newVehicleResponsibleMail = newUsers ? newUsers.map(user => user.email) : []
    },

    selectedResponsableMov: function(newUsers) {
      this.fields.newMovementResponsibleMail = newUsers ? newUsers.map(user => user.email) : []
    },

    // Watcher para dealershipId para recargar configuración cuando esté disponible
    dealershipId: {
      handler(newDealerId, oldDealerId) {
        console.log('🔄 dealershipId changed in Settings:', { old: oldDealerId, new: newDealerId })
        if (newDealerId && newDealerId !== oldDealerId) {
          console.log('✅ Valid dealershipId available, equipment configuration should reload automatically')
        }
      },
      immediate: true
    },

    // Watcher para CURRENT_USER para debugging
    CURRENT_USER: {
      handler(newUser) {
        console.log('🔄 CURRENT_USER changed in Settings:', newUser)
        if (newUser && newUser.dealer && newUser.dealer.id) {
          console.log('✅ User with dealer info available:', newUser.dealer.id)
        }
      },
      immediate: true,
      deep: true
    },

    selectedResponsableAlerts: function(newUsers) {
      this.fields.inProcessResponsibleMail = newUsers ? newUsers.map(user => user.email) : []
    }
  },

  methods: {
    previewLogo (file) {
      if (!file) {
        this.logoPreview = null
        return
      }

      // Generar vista previa del logo seleccionado
      this.logoPreview = URL.createObjectURL(file)
    },
    previewFirma (file) {
      if (!file) {
        return
      }

      // Generar vista previa del logo seleccionado
      this.fields.signature_image_url = URL.createObjectURL(file)
    },
    previewSello (file) {
      if (!file) {
        return
      }

      // Generar vista previa del logo seleccionado
      this.fields.stamp_image_url = URL.createObjectURL(file)
    },
    getRoleName (rol) {
      return this.roleDisplay[rol] || rol.charAt(0).toUpperCase() + rol.slice(1)
    },
    showUserForm (item) {
      this.editItem = item ? { ...item } : null
      this.visibleForm = true
      this.isLimitedEdit = true // Indica que es edición limitada desde settings
    },
    loadUserData () {
      UserService.getMe()
        .then(response => {
          this.user = response.data.data
          
          // Parse comodato_config if it's a JSON string
          if (this.user.dealer && this.user.dealer.comodato_config && typeof this.user.dealer.comodato_config === 'string') {
            try {
              this.user.dealer.comodato_config = JSON.parse(this.user.dealer.comodato_config)
              response.data.data.dealer.comodato_config = this.user.dealer.comodato_config
              console.log('[Settings] comodato_config parseado:', this.user.dealer.comodato_config)
            } catch (e) {
              console.error('[Settings] Error parseando comodato_config:', e)
            }
          }
          
          // this.fields.theme = response.data.data.dealer.theme
          this.fields.newVehicleResponsibleMail = response.data.data.dealer.config.newVehicleResponsibleMail
          this.fields.newMovementResponsibleMail = response.data.data.dealer.config.newMovementResponsibleMail
          
          // Convertir valores de alerta a números explícitamente
          this.fields.alert_period_from_unreported_to_reported = parseInt(response.data.data.dealer.config.alert_period_from_unreported_to_reported) || 0
          this.fields.alert_period_from_reported_to_processing = parseInt(response.data.data.dealer.config.alert_period_from_reported_to_processing) || 0
          this.fields.alert_period_from_processing_to_completed_driver = parseInt(response.data.data.dealer.config.alert_period_from_processing_to_completed_driver) || 0
          this.fields.alert_period_from_processing_to_completed_crane = parseInt(response.data.data.dealer.config.alert_period_from_processing_to_completed_crane) || 0
          this.fields.alert_period_from_processing_to_completed_customer = parseInt(response.data.data.dealer.config.alert_period_from_processing_to_completed_customer) || 0
          this.fields.alert_period_from_processing_to_completed_myself = parseInt(response.data.data.dealer.config.alert_period_from_processing_to_completed_myself) || 0
          
          this.fields.inProcessResponsibleMail = response.data.data.dealer.config.inProcessResponsibleMail
          this.fields.company_name = response.data.data.dealer.comodato_config.company_name
          this.fields.company_address = response.data.data.dealer.comodato_config.company_address
          this.fields.cif = response.data.data.dealer.comodato_config.cif
          // this.fields.wear_value = response.data.data.dealer.comodato_config.wear_value
          this.fields.franchises = response.data.data.dealer.comodato_config.franchises || []
          this.fields.km_limits = response.data.data.dealer.comodato_config.km_limits || []
          this.fields.default_franchise_index = response.data.data.dealer.comodato_config.default_franchise_index !== undefined ? parseInt(response.data.data.dealer.comodato_config.default_franchise_index) : null
          this.fields.default_km_limit_index = response.data.data.dealer.comodato_config.default_km_limit_index !== undefined ? parseInt(response.data.data.dealer.comodato_config.default_km_limit_index) : null
          this.fields.euros_per_km_exceeded = response.data.data.dealer.comodato_config.euros_per_km_exceeded || null
          this.fields.signature_image_url = response.data.data.dealer.comodato_config.signature_image_url
          this.fields.stamp_image_url = response.data.data.dealer.comodato_config.stamp_image_url
        })
        .catch(error => {
          console.error('Error al cargar los datos del usuario:', error)        
        })
    },

    loadResponsablesData() {
      UserService.get()
        .then(response => {
          this.userState.list = response.data.data
          this.userState.loading = false
          if (response.data.success && this.fields.newVehicleResponsibleMail) {
            // Handle arrays of emails from API
            const emails = Array.isArray(this.fields.newVehicleResponsibleMail) 
              ? this.fields.newVehicleResponsibleMail 
              : [this.fields.newVehicleResponsibleMail]
            this.selectedResponsable = response.data.data.filter(user => emails.includes(user.email))
          }
          if (response.data.success && this.fields.newMovementResponsibleMail) {
            // Handle arrays of emails from API
            const emails = Array.isArray(this.fields.newMovementResponsibleMail) 
              ? this.fields.newMovementResponsibleMail 
              : [this.fields.newMovementResponsibleMail]
            this.selectedResponsableMov = response.data.data.filter(user => emails.includes(user.email))
          }
          if (response.data.success && this.fields.inProcessResponsibleMail) {
            // Handle arrays of emails from API
            const emails = Array.isArray(this.fields.inProcessResponsibleMail) 
              ? this.fields.inProcessResponsibleMail 
              : [this.fields.inProcessResponsibleMail]
            this.selectedResponsableAlerts = response.data.data.filter(user => emails.includes(user.email))
          }
        })
        .catch(error => {
          console.error('Error al cargar los datos del usuario:', error)
        })
    },
    displayTextUser (item) {
      return `${item.name} ${item.lastname} - ${item.email}`
    },
    filterUsers (item, queryText, itemText) {
      const text = `${item.name} ${item.lastname} ${item.email}`.toLowerCase()
      const searchText = queryText.toLowerCase()
      return text.includes(searchText)
    },

    async changePassword () {
      if (!this.isPasswordFormValid) return

      this.saving2 = true
      try {
        let user = await UserService.getMe()
        const payload = {
          id: this.CURRENT_USER.id,
          username: user.data.data.email,
          name: user.data.data.name,
          lastname: user.data.data.lastname,
          password: this.fields.newPassword,
          roles: user.data.data.roles,
          status: user.data.data.status,
          permissions: user.data.data.permissions,
          phone: user.data.data.phone
        }

        const response = await UserService.put(payload)

        if (response.data.success) {
          this.$toast.success('Contraseña cambiada con éxito')

          // Limpiar campos después de cambiar la contraseña
          this.fields.newPassword = ''
          this.fields.newPasswordConfirm = ''

          // Actualizar después de un breve retraso
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        } else {
          this.$toast.error('Error al cambiar la contraseña')
        }
      } catch (error) {
        console.error('Error al cambiar la contraseña:', error)
        this.$toast.error('Ocurrió un error al cambiar la contraseña')
      } finally {
        this.saving2 = false
      }
    },

    async saveData () {
      this.saving = true
      try {
        const data = await UserService.getMe()
        const user = data.data.data

        const payload = {
          id: user.dealer.id,
          // theme: this.fields.theme,
          newVehicleResponsibleMail: this.fields.newVehicleResponsibleMail,
          newMovementResponsibleMail: this.fields.newMovementResponsibleMail
        }

        const response = await DealerService.put(payload)
        let logoSuccess = true

        if (this.fields.logo) {
          const formData = new FormData()
          formData.append('image', this.fields.logo)

          const logoResponse = await DealerService.addImage(user.dealer.id, formData)

          if (logoResponse.data.success && logoResponse.data.data && logoResponse.data.data.imageUrl) {
            localStorage.setItem('logo', JSON.stringify({
              id: logoResponse.data.data.imageUrl.id,
              url: logoResponse.data.data.imageUrl.url
            }))
          } else {
            logoSuccess = false
            this.$toast.error('Error al guardar el logo')
          }
        }

        if (response.data.success) {
          const message = logoSuccess
            ? 'Configuración guardada con éxito'
            : 'Tema guardado con éxito, pero hubo un problema con el logo'

          this.$toast.success(message)

          // Recargar la página después de un breve retraso
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        } else {
          this.$toast.error('Error al guardar los datos')
        }
      } catch (error) {
        console.error('Error al guardar los datos:', error)
        this.$toast.error('Ocurrió un error al guardar los datos')
      } finally {
        this.saving = false
      }
    },

    addFranchise() {
      // Validar que el valor sea un número positivo
      if (!this.newFranchise || this.newFranchise < 0) {
        this.$toast.error('Ingrese un valor válido para la franquicia')
        return
      }

      // Agregar el nuevo valor al array
      this.fields.franchises.push(parseFloat(this.newFranchise))
      
      // Limpiar el input
      this.newFranchise = null
    },

    removeFranchise(index) {
      // Eliminar la franquicia del array
      this.fields.franchises.splice(index, 1)
      
      // Ajustar el índice predeterminado si es necesario
      if (this.fields.default_franchise_index === index) {
        this.fields.default_franchise_index = null
      } else if (this.fields.default_franchise_index > index) {
        this.fields.default_franchise_index--
      }
    },

    setDefaultFranchise(index) {
      // Establecer la franquicia como predeterminada
      this.fields.default_franchise_index = index
    },

    addKmLimit() {
      // Validar que el valor sea un número positivo
      if (!this.newKmLimit || this.newKmLimit < 0) {
        this.$toast.error('Ingrese un valor válido para el límite de KM')
        return
      }

      // Agregar el nuevo valor al array
      this.fields.km_limits.push(parseFloat(this.newKmLimit))
      
      // Limpiar el input
      this.newKmLimit = null
    },

    removeKmLimit(index) {
      // Eliminar el límite de KM del array
      this.fields.km_limits.splice(index, 1)
      
      // Ajustar el índice predeterminado si es necesario
      if (this.fields.default_km_limit_index === index) {
        this.fields.default_km_limit_index = null
      } else if (this.fields.default_km_limit_index > index) {
        this.fields.default_km_limit_index--
      }
    },

    setDefaultKmLimit(index) {
      // Establecer el límite de KM como predeterminado
      this.fields.default_km_limit_index = index
    },

    async saveDataConfig () {
      this.saving = true
      try {
        const data = await UserService.getMe()
        const user = data.data.data
        // Extract emails from selected responsables (which is now an array)
        const selectedEmails = this.selectedResponsable ? this.selectedResponsable.map(user => user.email) : []
        const selectedEmailsMov = this.selectedResponsableMov ? this.selectedResponsableMov.map(user => user.email) : []
        const selectedEmailsProc = this.selectedResponsableAlerts ? this.selectedResponsableAlerts.map(user => user.email) : []
        
        // Update the field with the array of emails
        this.fields.newVehicleResponsibleMail = selectedEmails
        this.fields.newMovementResponsibleMail = selectedEmailsMov
        this.fields.inProcessResponsibleMail = selectedEmailsProc
        
        // Asegurar que todos los períodos de alerta sean números enteros
        const payload = {
          id: user.dealer.id,
          newVehicleResponsibleMail: this.fields.newVehicleResponsibleMail,
          newMovementResponsibleMail: this.fields.newMovementResponsibleMail,
          alert_period_from_unreported_to_reported: parseInt(this.fields.alert_period_from_unreported_to_reported) || 0,
          alert_period_from_reported_to_processing: parseInt(this.fields.alert_period_from_reported_to_processing) || 0,
          alert_period_from_processing_to_completed_driver: parseInt(this.fields.alert_period_from_processing_to_completed_driver) || 0,
          alert_period_from_processing_to_completed_crane: parseInt(this.fields.alert_period_from_processing_to_completed_crane) || 0,
          alert_period_from_processing_to_completed_customer: parseInt(this.fields.alert_period_from_processing_to_completed_customer) || 0,
          alert_period_from_processing_to_completed_myself: parseInt(this.fields.alert_period_from_processing_to_completed_myself) || 0,
          inProcessResponsibleMail: this.fields.inProcessResponsibleMail
        }
        
        console.log('Payload a enviar:', payload)

        const response = await DealerService.putConfig(payload)

        if (response.data.success) {
          const message = 'Configuración guardada con éxito'

          this.$toast.success(message)

          // Recargar la página después de un breve retraso
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        } else {
          this.$toast.error('Error al guardar los datos')
        }
      } catch (error) {
        console.error('Error al guardar los datos:', error)
        this.$toast.error('Ocurrió un error al guardar los datos')
      } finally {
        this.saving = false
      }
    },

    async saveDataComodatos () {
      this.saving = true
      try {
        const data = await UserService.getMe()
        const user = data.data.data

        const payload = new FormData()
        payload.append('id', user.dealer.id)
        payload.append('company_name', this.fields.company_name)
        payload.append('company_address', this.fields.company_address)
        payload.append('cif', this.fields.cif)
        // payload.append('wear_value', this.fields.wear_value)
        payload.append('franchises', JSON.stringify(this.fields.franchises))
        payload.append('km_limits', JSON.stringify(this.fields.km_limits))
        payload.append('default_franchise_index', this.fields.default_franchise_index !== null ? this.fields.default_franchise_index : '')
        payload.append('default_km_limit_index', this.fields.default_km_limit_index !== null ? this.fields.default_km_limit_index : '')
        payload.append('euros_per_km_exceeded', this.fields.euros_per_km_exceeded)
        payload.append('_signature_image', this.fields._signature_image)
        payload.append('_stamp_image', this.fields._stamp_image)

        const response = await DealerService.putComodatos(payload, user.dealer.comodato_config.id)

        if (response.data.success) {
          const message = 'Configuración guardada con éxito'

          this.$toast.success(message)

          // Recargar la página después de un breve retraso
          setTimeout(() => {
            window.location.reload()
          }, 2000)
        } else {
          this.$toast.error('Error al guardar los datos')
        }
      } catch (error) {
        console.error('Error al guardar los datos:', error)
        this.$toast.error('Ocurrió un error al guardar los datos')
      } finally {
        this.saving = false
      }
    },

    loadStoredLogo () {
      const storedLogo = localStorage.getItem('logo')
      if (storedLogo) {
        try {
          const logo = JSON.parse(storedLogo)
          if (logo && logo.url) {
            this.logoPreview = logo.url
          }
        } catch (error) {
          console.error('Error al cargar el logo del localStorage:', error)
        }
      }
    },

    removeResponsable(item) {
      const index = this.selectedResponsable.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedResponsable.splice(index, 1)
      }
    },

    removeResponsableMov(item) {
      const index = this.selectedResponsableMov.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedResponsableMov.splice(index, 1)
      }
    },

    // Actualizar usuarios responsables desde el componente de equipamientos
    updateEquipmentResponsibleUsers(responsibleUsers) {
      console.log('🔄 Updating equipment responsible users:', responsibleUsers)
      // Limpiar la selección actual si los usuarios del API están vacíos
      if (!responsibleUsers || responsibleUsers.length === 0) {
        this.selectedResponsableMov = []
        console.log('🧹 Cleared selectedResponsableMov')
      } else {
        // Si hay usuarios en el API, actualizar la selección
        this.selectedResponsableMov = responsibleUsers
      }
    },

    removeResponsableAlerts(item) {
      const index = this.selectedResponsableAlerts.findIndex(user => user.id === item.id)
      if (index > -1) {
        this.selectedResponsableAlerts.splice(index, 1)
      }
    },

    // Método para actualizar los datos después de guardar el usuario
    updateDataTable({ insert, value }) {
      // Recargar los datos del usuario para reflejar los cambios
      this.loadUserData()
      // Mostrar mensaje de éxito
      this.$toast.success('Información personal actualizada correctamente')
    }
  },

  created () {
    // Inicializar el tema almacenado
    this.fields.theme = 'light'
    
    // Solo hacer la petición a getMyManager si NO es admin
    if (!this.$store.getters.HAS_ROLE(['admin'])) {
      UserService.getMyManager()
        .then(response => {
          console.log(response.data.data)
        })
        .catch(error => {
          console.error('Error al cargar los datos del usuario para el tema:', error)
        })
    }

    // Cargar logo almacenado si existe (solo si no es admin)
    if (!this.$store.getters.HAS_ROLE(['admin'])) {
      this.loadStoredLogo()
    }
    
    // Siempre cargar los datos del usuario
    this.loadUserData()
    
    // Solo cargar responsables si no es admin
    if (!this.$store.getters.HAS_ROLE(['admin'])) {
      this.loadResponsablesData()
    }
  }
}
</script>

<style scoped>
.theme-color-preview {
  border-radius: 4px;
  overflow: hidden;
}

#pageSettings {
  animation: fadeIn 0.3s ease-out;
}

/* Estilo para las tabs */
.v-tabs {
  border-radius: 4px;
}

.v-tab {
  min-width: auto !important;
}

/* En móviles, hacemos que los iconos de las tabs sean más compactos */
@media (max-width: 600px) {
  .v-tab {
    min-width: 60px !important;
    padding: 0 6px !important;
  }
  .v-card-text {
    padding: 12px !important;
  }
  .v-card-actions {
    padding: 12px !important;
  }
  .v-card-title {
    padding: 12px !important;
    font-size: 18px !important;
  }
  .subtitle-1 {
    font-size: 15px !important;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
